<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row class="mb-3">
        <v-col cols="12" md="4">
          <DateIOSPicker label="Từ ngày" outlined dense outline :date.sync="dateFrom" @onEnterPress="onFilterChanged" />
        </v-col>
        <v-col cols="12" md="4">
          <DateIOSPicker label="Đến ngày" outlined dense outline :date.sync="dateTo" @onEnterPress="onFilterChanged" />
        </v-col>
        <v-col cols="12" md="4" class="mb-0 d-flex align-center">
          <v-checkbox class="ma-0 pa-0 mr-6" style="white-space: nowrap;" v-model="commendation" label="Về học tập" hide-details="auto"></v-checkbox>
          <v-checkbox class="ma-0 pa-0" style="white-space: nowrap;" v-model="violation" label="Về nội dung khác" hide-details="auto"></v-checkbox>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <GradeClassStudentSelect ref="grade-class-student-select" @changed="gradeClassStudentChange" />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import get from 'lodash-es/get'
import { Student } from '@/plugins/api'
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'

export default {
  components: {
    DateIOSPicker,
    GradeClassStudentSelect
  },
  data: () => ({
    selectedGrade: {},
    selectedClass: {},
    selectedStudent: {},
    time: null,
    dateData_gte: '',
    dateData_lte: '',
    dateRange: [],
    dateFrom: '',
    dateTo: '',
    commendation: false,
    violation: false
  }),
  props: {
    defaultStudentId: {
      type: String,
      default: () => ''
    }
  },
  methods: {
    gradeClassStudentChange(data) {
      this.selectedGrade = data.grade
      this.selectedClass = data.class
      this.selectedStudent = data.student
    },
    onFilterChanged() {
      if (this.dateFrom && this.dateTo) {
        this.dateData_gte = moment(this.dateFrom)
          .startOf('day')
          .toISOString()
        this.dateData_lte = moment(this.dateTo)
          .endOf('day')
          .toISOString()
      } else if (this.dateFrom) {
        this.dateData_gte = moment(this.dateFrom)
          .startOf('day')
          .toISOString()
        this.dateData_lte = moment().toISOString()
      } else if (this.dateTo) {
        this.dateData_lte = moment(this.dateTo)
          .endOf('day')
          .toISOString()
      }
      const params = {
        grade: get(this.selectedGrade, 'id'),
        class: get(this.selectedClass, 'id'),
        student: get(this.selectedStudent, 'id'),
        date_gte: this.dateData_gte,
        date_lte: this.dateData_lte,
        _sort: 'createdAt:desc'
      }

      if (!this.commendation || !this.violation) {
        if (this.commendation) params.type = 'commendation'
        if (this.violation) params.type = 'violation'
      }

      this.$emit('onFilterChanged', params)
    }
  },
  watch: {
    async defaultStudentId(newStudentId) {
      if (newStudentId) {
        const student = await Student.fetchOne(newStudentId)
        this.selectedStudent = student
        this.selectedClass = student.currentClass
        this.$refs['grade-class-student-select'].selectedStudent = student
        this.$refs['grade-class-student-select'].selectedClass = student.currentClass
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
